export const defaultConfig = {
    debug: false,
    dryRun: false,
    pageTitle: undefined,
    telemetryEnabled: true,
    events: {
        pageView: true,
        click: true,
        form: false,
        performance: true,
        visibility: true,
        modal: false,
    },
};
